import React from 'react';
import { Transfer } from 'antd';
import { TransferProps } from 'antd/lib/transfer';

export type { TransferProps };

const ProTransfer: React.FC<TransferProps<any>> = (props) => {
  const { children, ...resProps } = props;

  return (
    <Transfer {...resProps}>
      {children}
    </Transfer>
  );
};

export default ProTransfer;
